import React, { useState } from 'react';

import { withAuth } from '@/components/with_auth';
import Page from '@/components/layout/page';
import Title from '@/components/commons/page-elements/Title';
import ActionLoader from '@/components/commons/action_loader';
import WarningCard from '@/components/commons/warning_card';

import EmailDomainsTable from '@/components/inbox/email-domains/EmailDomainsTable';
import styles from '@/components/inbox/email-domains/EmailDomains.module.css';

function EmailDomains() {
    const [loading, setLoading] = useState(false);
    const [formError, setFormError] = useState('');

    return (
        <Page>
            <div className={`flex flex-wrap items-start w-full p-4 sm:p-8 ${styles.home}`}>
                <div className="pr-6 mb-10 text-left">
                    <Title title="Known Domains" subtitle="If you get a lot of email from a group or organization you trust, add them here and Sixty will treat everyone there as trusted." />
                </div>
                <ActionLoader isLoading={loading} />
                {
                    formError !== '' && (
                        <div className="w-full my-[20px]">
                            <WarningCard message={formError} />
                        </div>
                    )
                }
                <div className="bg-white rounded-md shadow-md border border-shadeStoneGray w-full">
                    <EmailDomainsTable
                        setLoading={setLoading}
                        setFormError={setFormError}
                        formError={formError}
                    />
                </div>
            </div>
        </Page>
    );
}

export default withAuth(EmailDomains);
